import { render, staticRenderFns } from "./GlobalFilialSelectItem.vue?vue&type=template&id=b6f87b80&scoped=true&"
import script from "./GlobalFilialSelectItem.vue?vue&type=script&lang=js&"
export * from "./GlobalFilialSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./GlobalFilialSelectItem.vue?vue&type=style&index=0&id=b6f87b80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f87b80",
  null
  
)

export default component.exports